import styled from 'styled-components';

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`;

export const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  border: 1px solid #CCCCCC;
  border-radius: 8px;
  padding: 16px;
  margin-top: 15px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin-right: 15px;

    svg {
      margin-right: 8px;
      transition: color 0.2s ease;
    }

    b {
      font-size: 14px;
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    background: none;
    border: none;

    &:hover {
      svg {
        color: #2C6EF2;
      }
    }
  }

  & + div {
    margin-left: 12px;
  }
`;
